module.exports = __webpack_public_path__ + "static/media/partner-autodesk.18d13513.png";